import type { SVGProps } from "react";

const QuestionnaireIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5001 1.66663H7.50008C7.03984 1.66663 6.66675 2.03972 6.66675 2.49996V4.16663C6.66675 4.62686 7.03984 4.99996 7.50008 4.99996H12.5001C12.9603 4.99996 13.3334 4.62686 13.3334 4.16663V2.49996C13.3334 2.03972 12.9603 1.66663 12.5001 1.66663Z"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 3.33337H14.9999C15.4419 3.33337 15.8659 3.50897 16.1784 3.82153C16.491 4.13409 16.6666 4.55801 16.6666 5.00004V16.6667C16.6666 17.1087 16.491 17.5327 16.1784 17.8452C15.8659 18.1578 15.4419 18.3334 14.9999 18.3334H4.99992C4.55789 18.3334 4.13397 18.1578 3.82141 17.8452C3.50885 17.5327 3.33325 17.1087 3.33325 16.6667V5.00004C3.33325 4.55801 3.50885 4.13409 3.82141 3.82153C4.13397 3.50897 4.55789 3.33337 4.99992 3.33337H6.66659"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 9.16663H13.3334M6.66675 12.5H10.8334"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QuestionnaireIcon;
